import { render, staticRenderFns } from "./ProgramareNouaMobile.vue?vue&type=template&id=670a9f10"
import script from "./ProgramareNouaMobile.vue?vue&type=script&lang=js"
export * from "./ProgramareNouaMobile.vue?vue&type=script&lang=js"
import style0 from "./ProgramareNouaMobile.vue?vue&type=style&index=0&id=670a9f10&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports